<template>
  <div>
    <h2 class="sui-header" id="requestHeader">ファイル引取依頼</h2>
    <div id="request" class="ui form">
      <div class="field" :class="{ 'error': $v.title.$error }">
        <label class="required">件名</label>
        <input
          id="Request-titleInput"
          type="text"
          placeholder
          v-model.trim="title"
          @blur="$v.title.$touch()"
          @focus="$v.title.$reset()"
        />
      </div>
      <div class="error" v-if="$v.title.$error && !$v.title.required">件名を入力してください</div>
      <div class="error" v-if="$v.title.$error && !$v.title.maxLength">件名の長さは60文字までです</div>

      <div class="field" :class="{ 'error': $v.password.$error }">
        <label class="required">アップロードパスワード</label>
        <div class="ui action input">
          <input
            id="Request-passwordInput"
            type="text"
            placeholder
            v-model.trim="password"
            @blur="$v.password.$touch()"
            @focus="$v.password.$reset()"
          />
          <button
            id="Request-createPasswordButton"
            class="ui button blue"
            @click="generatePassword"
          >自動生成</button>
        </div>
      </div>
      <div class="error" v-if="$v.password.$error && !$v.password.required">アップロードパスワードを入力してください</div>

      <div class="field" :class="{ 'error': $v.addresses.$error  }">
        <label class="required">宛先</label>
        <input
          id="Request-addressInput"
          type="text"
          placeholder
          v-model.trim="addresses"
          @blur="$v.addresses.$touch()"
          @focus="$v.addresses.$reset()"
        />
      </div>
      <div class="error" v-if="$v.addresses.$error && !$v.addresses.required">宛先を入力してください</div>
      <div
        class="error"
        v-if="$v.addresses.$error && $v.addresses.required && !$v.addresses.email"
      >E-mail形式で入力してください</div>

      <div class="field" :class="{ 'error':  $v.comments.$invalid }">
        <label>コメント（ファイル内容の補足）</label>
        <textarea
          id="Request-commentsTextarea"
          v-model="comments"
          @blur="$v.comments.$touch()"
          @focus="$v.comments.$reset()"
        ></textarea>
      </div>
      <div class="error" v-if="$v.comments.$invalid && !$v.comments.maxLength">コメントの長さは200文字までです</div>

      <div class="center-content">
        <button
          id="Request-requestButton"
          class="ui button green wide"
          :class="{'disabled': $v.$invalid}"
          @click="register"
        >ファイル引取依頼を送信する</button>
      </div>
    </div>
  </div>
</template>
<script>
import { required, helpers, email } from 'vuelidate/lib/validators'
import { getRandomStr } from '@/common'
import { exchangeFilePickUp } from '@/api'

export default {
  title: 'ファイル引取依頼',
  data: function () {
    return {
      title: '[Acroquest]',
      password: '',
      addresses: [],
      comments: ''
    }
  },
  validations: {
    title: {
      required,
      maxLength: (value) =>
        helpers.len(value) <= 60
    },
    password: {
      required
    },
    addresses: {
      required,
      email
    },
    comments: {
      maxLength: (value) =>
        helpers.len(value) <= 200
    }
  },
  methods: {
    register: function () {
      const self = this
      this.$store.commit('confirmModal/openModal', {
        title: 'ファイル引取依頼',
        message: 'ファイル引取依頼を送信します。 よろしいですか？',
        executeLabel: '送信',
        callback: function (answer) {
          if (answer) {
            this.$store.commit('progress/setLoading', true)
            exchangeFilePickUp(self.title, [self.addresses], self.password, self.comments).then(
              () => {
                this.$router.push({ name: 'exchangeList' })
              })
              .catch(error => {
                console.log(' error ' + error)
                this.$store.commit('progress/setLoading', false)
                this.$store.commit('infoModal/openModal', {
                  type: 'ERROR',
                  title: 'ファイル引取依頼',
                  message: '通信エラーが発生しました。\nしばらくしてからもう一度お試しください。'
                })
              })
          }
        }
      })
    },
    generatePassword: function () {
      this.password = getRandomStr(20)
    }
  }
}
</script>
<style>
#request {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

h2#requestHeader {
  max-width: 600px;
  margin: auto;
  margin-bottom: 20px;
}

.ui.button.wide {
  width: 400px;
  margin-top: 20px;
  font-size: large;
}

.required:after {
  content: " *";
  color: red;
}
</style>
